import { Core, DAMAGES_REROUTE } from '../Core';

class Damages extends Core {
  damagesReroute = async (data: { vehicleId: number }) =>
    this.post(DAMAGES_REROUTE(), data);
}

export const damages = new Damages();
